/*import { Link } from "react-router-dom";
import Input from "../Input/Input";*/
import Select from "../Select/Select";
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API } from "../../api/API-Url"
/*import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Pagination } from "swiper";*/
import "./Hero.scss";
import 'swiper/swiper-bundle.min.css';


import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
/*
import SearchActivity from "../SearchActivity/SearchActivity";
import TeamBuildingSection from "../TeamBuildingSection/TeamBuildingSection";*/

import FetchService from "../../api/FetchService";
import { getFilters } from "../../commons/activity-filters/Helpers";

let searchModal = {
    name: "",
    category: "",
    type: "",
    city: "",
    peopleNumber: "",
    budgetOptions: "",
};

let filter = {
    pageNo: 1,
    rowCountPerPage: 6,
    isValid: true,
    isLive: true,
    city: null,
    type: null,
    category: null,
    minPrice: -1,
    maxPrice: -1,
    minPerson: -1,
    maxPerson: -1,
};

function Hero({ setIsLoading }) {
    const navigate = useNavigate();

    const filters = getFilters();

    const [city, setCity] = useState("");
    const [type, setType] = useState("");
    const [category, setCategory] = useState("");
    const [peopleNumber, setPeopleNumber] = useState("");
    const [budget, setBudget] = useState("");

    const [activityCount, setActivityCount] = useState(0);
    const [activityCounter, setCounter] = useState(0);
    const [checking, setChecking] = useState(0);

    const [homeActivities, setHomeActivities] = useState([]);

    const [imagesHeader, setImagesHeader] = useState([]);

    const [indexes, setIndex] = useState(0);

    const [counter, setcounter] = useState(0);


    const [activeSlide, setActiveSlide] = useState(0);


    const [slideWidth, setSlideWidth] = useState(340.667); // Default fallback

    const debounce = (func, wait) => {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => func(...args), wait);
        };
    };

    useEffect(() => {
        const wrapper = document.querySelector('.swiper-wrapper');
        if (!wrapper) return;

        // Throttle instead of debounce for ResizeObserver
        const throttle = (func, limit) => {
            let lastFunc;
            let lastRan;
            return function (...args) {
                if (!lastRan) {
                    func(...args);
                    lastRan = Date.now();
                } else {
                    clearTimeout(lastFunc);
                    lastFunc = setTimeout(() => {
                        if ((Date.now() - lastRan) >= limit) {
                            func(...args);
                            lastRan = Date.now();
                        }
                    }, limit - (Date.now() - lastRan));
                }
            };
        };

        const calculateSlideWidth = () => {
            const firstSlide = wrapper.querySelector('.swiper-slide');
            if (!firstSlide) return;

            const gap = parseFloat(window.getComputedStyle(wrapper).gap) || 0;
            const renderedWidth = firstSlide.offsetWidth;

            // Use requestAnimationFrame to prevent layout thrashing
            requestAnimationFrame(() => {
                setSlideWidth(prev => {
                    const newWidth = renderedWidth + gap - 2;
                    return prev !== newWidth ? newWidth : prev;
                });
            });
        };

        // Optimized handlers
        const handleResize = throttle(() => {
            calculateSlideWidth();
        }, 100);

        const resizeObserver = new ResizeObserver(throttle(calculateSlideWidth, 100));

        // Initial calculation
        calculateSlideWidth();

        // Set up observers
        resizeObserver.observe(wrapper);
        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
            resizeObserver.disconnect();
        };
    }, [activeSlide]); // Empty dependency array - run once

    const handlePreviousClick = () => {

        let array = customfilter(imagesHeader);
        const newIndex = (activeSlide - 1 + array.length) % array.length;
        setActiveSlide(newIndex);
    };

    const handleNextClick = () => {
        let array = customfilter(imagesHeader);
        const newIndex = (activeSlide + 1) % array.length;
        setActiveSlide(newIndex);
    };

    useEffect(() => {
        const fetchData = async () => {
            try {
                await fetchActivitiesImages(imagesHeader.length);
            } catch (error) {
                console.error("Error fetching images:", error);
            }
        };

        fetchData(); // Immediately invoke the async function

    }, []);


    useEffect(() => {

        let time = 5000;
        let fetchInProgress = false; // Flag to track if fetch is in progress

        const timeoutCallback = () => {
            const fetchData = async () => {
                try {
                    // Fetch activities images only when indexes is 0
                    await fetchActivitiesImages(imagesHeader.length);
                } catch (error) {
                    // Handle any errors that may occur during the fetch
                    console.error("Error fetching images:", error);
                } finally {
                    // Reset the flag after fetch is complete
                    fetchInProgress = false;
                }
            };


            setcounter((prevIndex) => {
                if (prevIndex === imagesHeader.length - 4) {
                    // Set the flag to indicate a fetch is in progress
                    fetchInProgress = true;

                    // Invoke the fetchData function
                    fetchData();

                    return prevIndex + 1;
                }
                if (prevIndex < imagesHeader.length - 1) {
                    return prevIndex + 1;
                }
                else {
                    return 0;
                }
            })



            setIndex((prevIndex) => {
                const totalImages = imagesHeader.length;

                if (totalImages < 2) return 0; // Handle edge case where there's only one or no images

                const nextIndex = (prevIndex + 2) % totalImages; // Cyclic increment
                return Math.random() > 0.5 ? prevIndex : nextIndex; // Randomly pick between current and next index
            });


            // Set the next timeout after each iteration
            timeoutId = setTimeout(timeoutCallback, time); // 10 seconds timeout
        };

        // Start the first timeout
        let timeoutId = setTimeout(timeoutCallback, time); // 10 seconds initial timeout

        // Cleanup function
        return () => {
            // Clear the timeout when the component unmounts
            clearTimeout(timeoutId);
        };

    }, [imagesHeader, indexes]);



    const customfilter = (filter) => {

        let ispriority = filter?.filter(obj => obj.giftCardFavPriority);
        if (ispriority.length >= 6) {
            return ispriority;
        }
        else {
            return filter;
        }
    }




    const fetchData = () => {
        setIsLoading(true);
        let apicall = FetchService.getActivitiesByPagination(filter);

        apicall
            .then((response) => {
                return response.data;
            })
            .then((data) => {
                setActivityCount(data.pages[0]?.total);
            });

        setIsLoading(false);
    };

    function htmlToPlainText(html) {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = html;

        function traverse(node, indent) {
            let result = '';

            for (let i = 0; i < node.childNodes.length; i++) {
                const child = node.childNodes[i];

                if (child.nodeType === Node.TEXT_NODE) {
                    result += indent + child.textContent.trim() + ' ';
                }
                else if (child.nodeType === Node.ELEMENT_NODE) {
                    if (child.tagName.toLowerCase() === 'br') {
                        result += '/n';
                    }
                    else if (getComputedStyle(child).display === 'block') {
                        result += '/n' + indent + traverse(child, indent + '  ') + '\n';
                    }
                    else {
                        result += traverse(child, indent);
                    }
                }
            }

            return result;
        }

        return traverse(tempDiv, '').trim();
    }


    function truncateHTML(html, maxLength) {
        const tempElement = document.createElement("div");
        tempElement.innerHTML = html;

        let text = tempElement.textContent || tempElement.innerText || "";
        if (text.length > maxLength) {
            const truncatedText = text.substring(0, maxLength);
            const ellipsis = document.createElement("span");
            ellipsis.textContent = " ...";
            tempElement.textContent = truncatedText;
            tempElement.appendChild(ellipsis);
        }

        return tempElement.innerHTML;
    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        searchModal.type = type;
        searchModal.category = category;
        searchModal.budget = budget;
        searchModal.peopleNumber = peopleNumber;
        searchModal.city = city;
        sessionStorage.setItem("SearchResult", null);
        navigate("/aktiviteter", { state: searchModal });
    };

    const fetchActivitiesImages = (length=0) => {
        FetchService.getActivitiesImages(imagesHeader)
            .then((response) => {
                const data = response.data;
                let indeximages = 0 + length;

                data.forEach((image) => {
                    
                    if (image.thumbnailImage != null) {
                        const base64Image = image.thumbnailImage;
                        const jsonParse = JSON.parse(base64Image);
                        image.thumbnailImage = jsonParse[0].imageURL;
                    } else {
                        const base64Image = image.imageURLs;
                        image.thumbnailImage = base64Image;
                    }

                    image.thumbnailImage = image.thumbnailImage.replace("{baseApiURL}", "https://funtlers.com/")

              
                });

                

                let updated = [...imagesHeader];

                updated = updated.concat(data);
                setImagesHeader(updated);

                console.log(imagesHeader);

            })
            .catch((error) => {
                // Handle API request errors here
                console.error("Błąd żądania API:", error);
            });
    };

    useEffect(() => {
        fetchData();

        if (activityCount !== activityCounter) {
            activityCounterCount()
        }

    }, [activityCount]);

    const activityCounterCount = () => {
        let i = 0;
        setInterval(function () {
            if (i < activityCount) {
                i++
                setCounter(i)
            }
        }, 9)
    }

    function handleActivityPage(activityName, id) {
        const urlFriendlyString = encodeURIComponent(activityName.replace(/ /g, '-'));
        return window.location.href = window.location.origin + `/aktivitet/${urlFriendlyString}?id=${id}`
    }

    function getUrlFriendlyString(activityName, category) {
        
        const firstCategory = category.split(",")[0].toLowerCase().replace(/\s+/g, "");

        const headerHeadingClean = firstCategory
            ?.toLowerCase()
            ?.replace(/\s+/g, "")
            ?.replace("dagsevent", "pakontoret")
            ?.replace("julebord", "firmafest");


        return firstCategory +"/"+encodeURIComponent(activityName.replace(/ /g, '-'));
    }

    return (
        <>

            <main >
                <section className="hero-section lg-container">
                    <div className="">
                        <div className="fn-container">
                            <div className="content-container">
                                <div className="text-content">
                                    <h2 className="title d-sm-block d-none"> MARKEDSPLASSEN <br />
                                        <span className="highlights"> FOR SOSIALE AKTIVITETER</span>
                                    </h2>
                                    <p className="text-details"> Fyll minnebanken med rimelige opplevelser. For både privat personer og bedrift. </p>
                                    <form onSubmit={handleSubmit}>

                                        <div className="details-container">
                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("vennegjeng");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.555" height="22.555" viewBox="0 0 29.555 29.555">
                                                                <path d="M241.866,3.464a.866.866,0,0,0,.866-.866V.866a.866.866,0,0,0-1.732,0V2.6A.866.866,0,0,0,241.866,3.464Zm0,0" transform="translate(-227.088)" fill="#ffeeec" />
                                                                <path d="M302.478,33.21l1.732-1.732a.866.866,0,0,0-1.224-1.224l-1.732,1.732a.866.866,0,0,0,1.224,1.224Zm0,0" transform="translate(-283.624 -28.268)" fill="#ffeeec" />
                                                                <path d="M152.986,33.21a.866.866,0,0,0,1.224-1.224l-1.732-1.732a.866.866,0,0,0-1.224,1.224Zm0,0" transform="translate(-142.284 -28.268)" fill="#ffeeec" />
                                                                <path d="M21.927,155.464a3.464,3.464,0,1,0-3.464,3.464A3.467,3.467,0,0,0,21.927,155.464Zm0,0" transform="translate(-14.134 -143.226)" fill="#ffeeec" />
                                                                <path d="M14.778,121a2.6,2.6,0,0,0-2.6,2.6,6.168,6.168,0,0,1-6.119,6.119H4.329A4.335,4.335,0,0,0,0,134.046V142.7a.866.866,0,0,0,.866.866H7.793a.856.856,0,0,0,.854-.865l0-8.1A11.346,11.346,0,0,0,17.375,123.6a2.6,2.6,0,0,0-2.6-2.6Zm0,0" transform="translate(0 -114.015)" fill="#ffeeec" />
                                                                <path d="M383.927,155.464a3.464,3.464,0,1,0-3.464,3.464A3.467,3.467,0,0,0,383.927,155.464Zm0,0" transform="translate(-355.238 -143.226)" fill="#ffeeec" />
                                                                <path d="M286.681,230.816H284.95a6.2,6.2,0,0,1-4.909-2.523,12.8,12.8,0,0,1-2.568,4.8,11.614,11.614,0,0,0,4.886,2.615l.005,8.1a.856.856,0,0,0,.854.865h6.927a.866.866,0,0,0,.866-.866v-8.659A4.335,4.335,0,0,0,286.681,230.816Zm0,0" transform="translate(-261.455 -215.115)" fill="#ffeeec" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Vennegjeng</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("datenight");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.814" height="22.663" viewBox="0 0 31.814 29.663">
                                                                <g transform="translate(0)">
                                                                    <g transform="translate(0 0)">
                                                                        <g transform="translate(0 0)">
                                                                            <path d="M30.987,21.869a8.022,8.022,0,0,0-7.665-4.829,7.965,7.965,0,0,0-7.416,4.049A7.967,7.967,0,0,0,8.491,17.04,8.022,8.022,0,0,0,.826,21.869c-1.68,3.772-.752,8.446,2.364,11.907,2.082,2.313,12.239,12.667,12.34,12.77a.53.53,0,0,0,.755,0c.1-.1,10.258-10.456,12.34-12.77C31.74,30.314,32.667,25.641,30.987,21.869ZM22.673,34.087c-1.089,1.209-6.338,6.581-6.389,6.631a.529.529,0,0,1-.755,0c-.05-.051-5.3-5.423-6.389-6.631a6.057,6.057,0,0,1-1.263-6.449,4.394,4.394,0,0,1,4.195-2.652,4.416,4.416,0,0,1,3.835,2.022,4.415,4.415,0,0,1,3.835-2.022,4.394,4.394,0,0,1,4.195,2.652A6.057,6.057,0,0,1,22.673,34.087Z" transform="translate(0.001 -17.04)" fill="#ffeeec" />
                                                                            <path d="M145.7,159.732a3.437,3.437,0,0,0-3.342,2.312.529.529,0,0,1-.986,0,3.437,3.437,0,0,0-3.342-2.312,3.373,3.373,0,0,0-3.226,2.023,5,5,0,0,0,1.083,5.31c.889.987,4.718,4.92,5.979,6.211,1.261-1.291,5.089-5.224,5.979-6.211a5,5,0,0,0,1.083-5.31A3.374,3.374,0,0,0,145.7,159.732Z" transform="translate(-125.957 -150.727)" fill="#ffeeec" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Datenight</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("bursdag");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.297" height="22.777" viewBox="0 0 27.297 26.777">
                                                                <g transform="translate(0 -4.88)">
                                                                    <path d="M106.32,9.519a1.625,1.625,0,0,0,1.625-1.625,8.686,8.686,0,0,0-1.2-2.771.488.488,0,0,0-.844,0,8.687,8.687,0,0,0-1.2,2.771A1.625,1.625,0,0,0,106.32,9.519Z" transform="translate(-99.113 0)" fill="#ffeeec" />
                                                                    <path d="M227.151,9.519a1.625,1.625,0,0,0,1.625-1.625,8.686,8.686,0,0,0-1.2-2.771.488.488,0,0,0-.844,0,8.687,8.687,0,0,0-1.2,2.771A1.625,1.625,0,0,0,227.151,9.519Z" transform="translate(-213.502 0)" fill="#ffeeec" />
                                                                    <path d="M347.981,9.519a1.625,1.625,0,0,0,1.625-1.625,8.687,8.687,0,0,0-1.2-2.771.488.488,0,0,0-.844,0,8.687,8.687,0,0,0-1.2,2.771A1.625,1.625,0,0,0,347.981,9.519Z" transform="translate(-327.89 0)" fill="#ffeeec" />
                                                                    <path d="M105.614,116.951a.72.72,0,0,0-.72.72v5.807h3.228v-5.807a.72.72,0,0,0-.72-.72h-1.789Z" transform="translate(-99.302 -106.096)" fill="#ffeeec" />
                                                                    <path d="M226.444,116.951a.72.72,0,0,0-.72.72v5.807h3.228v-5.807a.72.72,0,0,0-.72-.72h-1.789Z" transform="translate(-213.69 -106.096)" fill="#ffeeec" />
                                                                    <path d="M347.275,116.951a.72.72,0,0,0-.72.72v5.807h3.228v-5.807a.72.72,0,0,0-.72-.72h-1.789Z" transform="translate(-328.079 -106.096)" fill="#ffeeec" />
                                                                    <path d="M44.679,278.816a1.394,1.394,0,0,0,.4-.058l2.019-.6a7.219,7.219,0,0,1,4.072,0l1.593.472a7.223,7.223,0,0,0,4.072,0l1.593-.472a7.219,7.219,0,0,1,4.072,0l2.019.6a1.4,1.4,0,0,0,.4.058,1.145,1.145,0,0,0,1.215-1.053V275.7a1.345,1.345,0,0,0-1.431-1.238H44.9a1.345,1.345,0,0,0-1.431,1.238v2.062A1.145,1.145,0,0,0,44.679,278.816Z" transform="translate(-41.147 -255.211)" fill="#ffeeec" />
                                                                    <path d="M26.5,374.112H24.314v-4.9a2.978,2.978,0,0,1-1.4-.072l-2.019-.6a5.62,5.62,0,0,0-3.164,0l-1.593.472a8.82,8.82,0,0,1-4.98,0l-1.593-.472a5.62,5.62,0,0,0-3.164,0l-2.019.6a2.977,2.977,0,0,1-1.4.072v4.9H.8a.8.8,0,1,0,0,1.6H26.5a.8.8,0,0,0,0-1.6Z" transform="translate(0 -344.055)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Bursdag</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("familiedag");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.908" height="22.891" viewBox="0 0 27.908 27.891">
                                                                <g transform="translate(-467 -610.349)">
                                                                    <path d="M45.174,48.14a.537.537,0,0,1-.174.348l.653,4.963A1.531,1.531,0,0,1,45,54.888,1.223,1.223,0,0,0,46.393,53.8l.74-6.095a8.847,8.847,0,0,1-1.872-.3Z" transform="translate(441.155 583.191)" fill="#ffeeec" />
                                                                    <path d="M54.938,46.9a9.31,9.31,0,0,1-2.438.479l.74,6.095a1.25,1.25,0,0,0,2.481-.3Z" transform="translate(436.92 583.474)" fill="#ffeeec" />
                                                                    <ellipse cx="2.394" cy="2.394" rx="2.394" ry="2.394" transform="translate(470.701 610.349)" fill="#ffeeec" />
                                                                    <path d="M9.967,30.271a5.018,5.018,0,0,1-.784-.435l.609-3.047a1.032,1.032,0,0,1-1.524-1.306c0-.044,1.785-3.613,1.654-3.4a1.106,1.106,0,0,1,.566-.522c.044-.653.261-3.526.261-3.308.044.218.131.392.174.609A1.739,1.739,0,0,1,12.4,18a23.988,23.988,0,0,0-1.175-3.221c-1.175-2.568-7.618-2-8.489.044A20.921,20.921,0,0,0,1,21.87a.828.828,0,0,0,1.654.087,17.286,17.286,0,0,1,.653-3.787l.609,8.01c0,.131.131.218.261.261L3.263,34.1a1.25,1.25,0,0,0,2.481.3l.914-7.966h.7l.958,7.923a1.243,1.243,0,0,0,2.046.784,1.225,1.225,0,0,1-.435-.914V30.271Z" transform="translate(466.002 602.584)" fill="#ffeeec" />
                                                                    <path d="M50.189,19.836a10.263,10.263,0,0,0-1.175-3.352v1.7L50.581,26.1a9.036,9.036,0,0,1-7.183,1c.044-.522-.131,1.915.392-5.137a4.286,4.286,0,0,0,2.22-3.57,1.245,1.245,0,0,0-2.481-.218,1.954,1.954,0,0,1-.522,1.349c-.174-.087-.392-.174-.566-.261l.174-.914a2.231,2.231,0,0,0-.914-3.178c1.088-2.133.827-1.872,1.262-2.133a6,6,0,0,1,5.311-.218c1.654.7,3.352,4.963,3.613,6.747A.859.859,0,0,1,50.189,19.836Z" transform="translate(443.018 603.006)" fill="#ffeeec" />
                                                                    <path d="M47.894,5.689a2.387,2.387,0,0,0,2.394-2.394,2.394,2.394,0,1,0-4.789,0A2.415,2.415,0,0,0,47.894,5.689Z" transform="translate(440.873 609.449)" fill="#ffeeec" />
                                                                    <path d="M37.085,23.057a1.8,1.8,0,0,0,1.785-1.828,1.9,1.9,0,0,0-1.045-1.654,2.051,2.051,0,0,0-.74-.174A1.765,1.765,0,0,0,35.3,21.185a1.841,1.841,0,0,0,1.785,1.872Z" transform="translate(446.632 599.002)" fill="#ffeeec" />
                                                                    <path d="M37.968,40.389l-.653-4.832-.044-.392a.187.187,0,0,0,.174-.174c.392-4.614.522-6.573.522-6.53a3.712,3.712,0,0,0,2.177-3.352.832.832,0,1,0-1.654-.174,2.228,2.228,0,0,1-.914,1.828,5.407,5.407,0,0,0-1.828-.653,2.289,2.289,0,0,1-1.045,0,3.265,3.265,0,0,0-1.393.435c-.522.261-1.306.827-1.219,1.349a.862.862,0,0,1,.479.479c0,.044,1.785,3.613,1.654,3.4a1.016,1.016,0,0,1-1.306,1.393c0,.044.131,1.915.131,1.785a.187.187,0,0,0,.174.174c-.784,5.7-.7,5.224-.7,5.224a1.031,1.031,0,1,0,2.046.261l.435-3.221.218,1.567.218,1.741a1.455,1.455,0,0,0,2.177,1.045,1.283,1.283,0,0,1-.566-.218.988.988,0,0,0,.914-1.132Z" transform="translate(448.448 596.297)" fill="#ffeeec" />
                                                                    <path d="M22.4,53l.044.261v3.526a.827.827,0,0,0,1.654,0v-3.4A5.994,5.994,0,0,1,22.4,53Z" transform="translate(453.917 580.029)" fill="#ffeeec" />
                                                                    <path d="M32.416,59.021c.3-.479.131-.827.174-3.221l-.3,2.394A1.835,1.835,0,0,0,32.416,59.021Z" transform="translate(448.341 578.448)" fill="#ffeeec" />
                                                                    <path d="M28.3,56.787a.827.827,0,0,0,1.654,0V53a5.4,5.4,0,0,1-1.654.392Z" transform="translate(450.585 580.029)" fill="#ffeeec" />
                                                                    <path d="M24,26.737A1.437,1.437,0,1,0,25.437,25.3,1.437,1.437,0,0,0,24,26.737Z" transform="translate(453.013 595.671)" fill="#ffeeec" />
                                                                    <path d="M25.194,40.641c0-.044-1-5.05-.914-4.745v-.522c0,.044.914,1.872.914,1.828a.633.633,0,0,0,1.132-.566c-1.785-3.613-1.524-3.613-2.743-4-.174-.044-.3-.087-.479-.131a1.8,1.8,0,0,1-1.349,0,5.162,5.162,0,0,0-1.219.435.508.508,0,0,0-.261.261c-2.873,5.833.174-.348-1.654,3.4a.6.6,0,0,0,.174.74.639.639,0,0,0,.958-.218c.174-.392.871-1.785.827-1.7v.392c-.784,3.961-.958,4.789-.914,4.745A5.008,5.008,0,0,0,25.194,40.641Z" transform="translate(456.085 591.605)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Famile dag</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("egentid");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.211" height="22.554" viewBox="0 0 16.211 30.554">
                                                                <g transform="translate(0)">
                                                                    <path d="M6.762,77.932A16.671,16.671,0,0,0,10.208,72a15.755,15.755,0,0,0,.594-2.505,27.21,27.21,0,0,1,2.286,7.615,1.572,1.572,0,0,0,3.106-.485,28.4,28.4,0,0,0-3.635-10.475,1.255,1.255,0,0,1-.368-.18,9.051,9.051,0,0,1-2.96-3.355,7.3,7.3,0,0,1-.753-3.251,7.408,7.408,0,0,1,.573-2.891l0,0,.006-.013a1.263,1.263,0,0,1,1.139-.722,1.258,1.258,0,0,1,1.138,1.79c-.008.02-.02.049-.036.089-.029.077-.074.2-.121.374a5.257,5.257,0,0,0-.185,1.376,4.852,4.852,0,0,0,.5,2.144l.025.048c.152-1.311.439-2.584.638-3.6.361-1.251-.111-2.749-1.184-3.017a2.418,2.418,0,0,0-1.524.153l.016-.062s-3-6.36-7.23-2.336c-2.011,1.912-.2,3.867.389,3.867S-1.4,58.149.44,62.591s5.6,3.886,6.108,2.8a13.663,13.663,0,0,0,.444-1.322v.005A2.884,2.884,0,0,0,7.71,65.59a9.072,9.072,0,0,1,.126,1.6,12.451,12.451,0,0,1-.616,3.836,13.519,13.519,0,0,1-2.807,4.82,1.572,1.572,0,0,0,2.349,2.088ZM4.128,54.991a1.056,1.056,0,1,1,1.056,1.056A1.056,1.056,0,0,1,4.128,54.991Zm-1.174-.514a1.819,1.819,0,0,1,3.482-.737l-.168.17a1.532,1.532,0,1,0-2.121,2.145l-.092.093a1.819,1.819,0,0,1-1.1-1.671Z" transform="translate(-0.001 -47.906)" fill="#ffeeec" />
                                                                    <ellipse cx="2.828" cy="2.828" rx="2.828" ry="2.828" transform="translate(8.038 5.51) rotate(-76.881)" fill="#ffeeec" />
                                                                    <path d="M71.438,91.538a5.5,5.5,0,0,1,.194-1.443c.048-.175.1-.311.128-.4.017-.043.03-.075.037-.092l.006-.013a1.006,1.006,0,0,0-1.821-.854h0a7.231,7.231,0,0,0,.171,5.941,8.8,8.8,0,0,0,2.88,3.26A1.006,1.006,0,0,0,74.2,96.3a6.789,6.789,0,0,1-2.244-2.509A5.075,5.075,0,0,1,71.438,91.538Z" transform="translate(-60.697 -80.082)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Egen tid</p>
                                                </div>
                                            </button>


                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("dagsutflukt");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.645" height="22.645" viewBox="0 0 27.645 27.645">
                                                                <g transform="translate(0)">
                                                                    <path d="M3.294,163.884v2.5h1.62v-2.5c1.466-.238,3.24-1.246,3.24-4.785,0-3.382-1.541-8.1-4.05-8.1S0,155.717,0,159.1C0,162.638,1.827,163.645,3.294,163.884Z" transform="translate(0 -142.847)" fill="#ffeeec" />
                                                                    <path d="M166.388,11.656V9.628a3.985,3.985,0,0,0,2.43-3.906c0-1.924-1.144-5.723-3.24-5.723s-3.24,3.8-3.24,5.723a3.985,3.985,0,0,0,2.43,3.906v1.764h-8.1V9.628a3.985,3.985,0,0,0,2.43-3.906C159.1,3.8,157.955,0,155.859,0s-3.24,3.8-3.24,5.723a3.985,3.985,0,0,0,2.43,3.906v1.764h-3.226a16.063,16.063,0,0,1,.7,3.24h8.194a1.62,1.62,0,0,1,0,3.24H159.1a8.155,8.155,0,0,0-8.1,8.153v1.62h9.719v-1.62a3.289,3.289,0,0,1,3.24-3.294h.81a5.645,5.645,0,0,0,1.62-11.074Z" transform="translate(-142.847 0.001)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Dagsutflukt</p>
                                                </div>
                                            </button>


                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("teambuilding");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.414" height="22.356" viewBox="0 0 29.414 30.356">
                                                                <path d="M50.359,33c.711,1.043.711,3.983.711,4.03a.237.237,0,1,1-.474,0c.047-2.75-.664-1.9-.284-3.84Z" transform="translate(-44.527 -17.828)" fill="#ffeeec" />
                                                                <path d="M37.189,13.521A2.571,2.571,0,1,1,36.9,8.4a2.572,2.572,0,0,1,.284,5.121Z" transform="translate(-25.336 -4.891)" fill="#ffeeec" />
                                                                <path d="M37.9,45.4a3.02,3.02,0,0,0,1.8,1.517l-.095,1.09a2.349,2.349,0,0,0,.095.806l.142.379.522,3.983a1.361,1.361,0,1,1-2.7.332L37,48.34a1.365,1.365,0,0,1,.047-.616Z" transform="translate(-27.561 -24.349)" fill="#ffeeec" />
                                                                <path d="M2.689,23.78a.948.948,0,0,1,1.09.664,7.011,7.011,0,0,0,2.655,3.7,4.519,4.519,0,0,1,4.5-.237,6.331,6.331,0,0,0,2.323-3.414.866.866,0,0,1,1.09-.664.83.83,0,0,1,.664,1.043,8.69,8.69,0,0,1-3.129,4.6c-.616,6.4-.284,6.827-.806,6.827l.095,1.185,1.754,4.03a1.114,1.114,0,1,1-2.039.9c-2.228-5.215-1.849-3.84-2.086-6.021L8.142,39l.664,2.845a1.144,1.144,0,1,1-2.228.522l-.759-3.129a1.156,1.156,0,0,1,0-.569l.664-2.418c-.332-.095-.095-.19-.664-6.353-.047,0-.095-.047-.142-.047a8.714,8.714,0,0,1-3.7-4.978A.929.929,0,0,1,2.689,23.78Z" transform="translate(14.379 -12.97)" fill="#ffeeec" />
                                                                <ellipse cx="2.371" cy="2.371" rx="2.371" ry="2.371" transform="translate(20.862 9.388)" fill="#ffeeec" />
                                                                <path d="M52.065,1,55,2.517l-.711,4.931c.522,3.034.569,3.651,1.659,4.6a2.364,2.364,0,0,1,.948,1.47,1.779,1.779,0,0,0-.474.047,2,2,0,0,0-.806-1.185c-1.28-1.185-1.328-2.276-1.754-4.789L50.5,3.94Zm1.328,2.134a.515.515,0,0,0,.569.332.45.45,0,0,0,.332-.569.515.515,0,0,0-.569-.332A.436.436,0,0,0,53.392,3.134Zm-1.517,1a.515.515,0,0,0,.332-.569.5.5,0,1,0-.948.284A.61.61,0,0,0,51.875,4.129Z" transform="translate(-50.5 -1)" fill="#ffeeec" />
                                                                <path d="M36.375,26.681c.237.047.095.047,3.129,1.47l.379-.427.379-.427,1.659-1.849a.9.9,0,0,1,1.28-.095.95.95,0,0,1,.095,1.28l-2.7,3.034c-.047,0-.474.711-1.185.379-.047,0-3.7-1.754-3.509-1.659a.858.858,0,0,1-.427-1.185A.773.773,0,0,1,36.375,26.681Z" transform="translate(-29.927 -13.69)" fill="#ffeeec" />
                                                                <path d="M30.221,34.628c0-.047.142-1.517.142-1.47a2.734,2.734,0,0,1-2.181-3.129,15.332,15.332,0,0,0,.19-2.513,43.532,43.532,0,0,0,3.034-3.366,1.3,1.3,0,0,0-.095-1.9,1.344,1.344,0,0,0-1.9.095L27.992,23.96c-.095-.379-.142-.616-.142-.616a2.716,2.716,0,1,1,5.215-1.517,24.006,24.006,0,0,1,.711,7.728,5.029,5.029,0,0,1-.522,2.276c0,.047-.284,2.892-.237,2.7l1.8,4.836a1.39,1.39,0,0,1-.806,1.754,1.35,1.35,0,0,1-1.754-.806l-1.9-5.121A.591.591,0,0,1,30.221,34.628Z" transform="translate(-17.704 -10.922)" fill="#ffeeec" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Teambuilding</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("sommerfest");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">

                                                            <svg width="26px" height="26px" viewBox="0 0 512 512"
                                                                xmlns="http://www.w3.org/2000/svg">
                                                                <path fill="#ffeeec" d="M122.7 23.32l1.7 21.87-16.7 14.25 21.4 5.17 8.4 20.25L149 66.18l21.8-1.75-14.2-16.71 5.1-21.32-20.3 8.35-18.7-11.43zM464 32a16 16 0 0 0-16 16 16 16 0 0 0 16 16 16 16 0 0 0 16-16 16 16 0 0 0-16-16zM239.8 42.5a16 16 0 0 0-16 16 16 16 0 0 0 16 16 16 16 0 0 0 16-16 16 16 0 0 0-16-16zm183.9 6.84c-9.2 1.74-17.7 7.18-25.9 14.28-7.6 6.53-14.7 14.66-20.7 23.45-18.8 3.01-37.6 10.67-50.2 21.13-16.1 13.2-30.4 35.8-38.2 59.1-7.4 3.1-14.4 6.8-20.1 10.8-15.5 10.9-23.5 31.8-29.4 50-5.9 18.3-8.8 34.3-8.8 34.3l17.8 3.2s2.7-15 8.1-31.9c5.5-16.9 14.8-35.3 22.7-40.8 1.3-.9 3-1.9 4.5-2.8-.6 5.7-.6 11.4.3 16.8 1.8 11.4 8 22.3 19 28.2 7.8 4.2 16.6 3.2 24 .2 7.4-3.1 14-8.2 19.7-14.2 5.7-6 10.4-13.1 13.2-20.6 2.8-7.5 3.8-16 .2-23.9h-.1c-3.9-8.4-11.4-13.8-19.4-16.1-8-2.3-16.6-2.2-25.2-.9-1.5.2-2.9.7-4.4 1 7.4-15.8 18-30.7 27.5-38.6 6.2-5.1 16.6-10 27.7-13.6-1.4 3.8-2.5 7.6-3 11.5-1.6 10.5.7 21.9 9.1 29.7 6.1 5.6 14.3 6.5 21.5 5.3 7.1-1.2 14-4.4 20.2-8.5 6.2-4.2 11.7-9.4 15.6-15.5 3.9-6.1 6.5-13.9 4-21.7v-.1c-3.3-10.07-11.5-16.99-20.6-20.27-3.9-1.4-8-2.19-12.2-2.66 2.9-3.26 5.9-6.31 8.9-8.92 6.8-5.84 13.7-9.5 17.6-10.23l-3.4-17.68zM174.8 84.39l-15.2 9.56 34.5 55.25-56.4 2.9 26.5 57.8 16.4-7.6-15.5-33.6 60.6-3.1-50.9-81.21zm216.4 19.31c6.1-.1 11.5.6 15.5 2.1 5.4 1.9 8.1 4.3 9.5 8.8.4 1.1.2 3.3-1.9 6.6-2.2 3.4-6.1 7.2-10.5 10.2-4.5 3-9.5 5.1-13.2 5.7-3.8.7-5.5 0-6.3-.7-3.5-3.2-4.5-7.2-3.5-13.9.8-5.4 3.3-11.9 7-18.6 1.2 0 2.3-.2 3.4-.2zM94.99 123a16 16 0 0 0-16 16 16 16 0 0 0 16 16A16 16 0 0 0 111 139a16 16 0 0 0-16.01-16zm356.11 37.2l-14.4 16.6-21.8-1.8 11.4 18.8-8.5 20.2 21.4-5 16.6 14.3 1.9-21.9 18.7-11.4-20.2-8.5-5.1-21.3zm-123.5 16.5c2.9.1 5.6.5 7.7 1.1 4.3 1.2 6.6 3 8.2 6.4.9 1.9 1 5.4-.7 10-1.7 4.7-5.2 10.1-9.4 14.6s-9.3 8.1-13.5 9.8c-4.2 1.7-6.8 1.6-8.5.7h-.1c-5.8-3.2-8.6-7.8-9.7-15.2-1-6.3-.3-14.3 1.8-22.9 4.9-1.7 9.8-3.1 14.5-3.8 3.5-.5 6.7-.7 9.7-.7zm-202.4 51.9c-7.2-.2-11.7 1.5-14.5 4.3-2.8 2.8-4.5 7.3-4.3 14.5.2 7.3 2.6 16.9 7.2 27.6 9.2 21.5 27.3 47.4 51.6 71.8 24.3 24.3 50.3 42.3 71.8 51.5 10.6 4.6 20.2 7 27.5 7.2 7.3.3 11.7-1.5 14.5-4.3 2.8-2.8 4.6-7.2 4.3-14.5-.2-7.3-2.6-16.9-7.2-27.6-9.2-21.4-27.2-47.4-51.5-71.7-24.3-24.4-50.3-42.4-71.8-51.6-10.7-4.6-20.3-7-27.6-7.2zm232 31.3l-33 54-29.1-27.9-12.4 13 45.1 43.3 33.8-55.2 38.7 32.3 89.3-38.2-7-16.6-79.3 34-46.1-38.7zM93.43 272.6l-17.64 57.9c41.41 49.1 89.71 76.7 142.11 94.7l21.6-6.6c-3.1-1.1-6.4-2.4-9.7-3.8-24.4-10.4-51.7-29.6-77.3-55.3-25.7-25.7-44.9-53-55.34-77.4-1.41-3.2-2.65-6.4-3.73-9.5zm-23.82 78.2l-14.01 46c28.89 27 59 39.2 90.6 50.2l43.4-13.2c-43.2-17.6-84-43.3-119.99-83zM368 352a16 16 0 0 0-16 16 16 16 0 0 0 16 16 16 16 0 0 0 16-16 16 16 0 0 0-16-16zM49.81 415.9l-20.29 66.6 88.28-26.9c-22.77-9.1-45.78-20.7-67.99-39.7z" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Firmafest</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("afterWork");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.324" height="22.202" viewBox="0 0 34.324 33.202">
                                                                <g transform="translate(0)">
                                                                    <ellipse cx="2.585" cy="2.585" rx="2.585" ry="2.585" transform="translate(7.607 1.8)" fill="#ffeeec" />
                                                                    <path d="M13.539,29.611H7.928L4.013,28.124l-1.59-4.5a1.247,1.247,0,1,0-2.352.83L1.854,29.5a1.247,1.247,0,0,0,.733.751l4.287,1.628V46.158l-4.5.351A1.5,1.5,0,0,0,2.6,49.493l5.884-.458a1.5,1.5,0,0,0,1.38-1.492V41.562h.646V53.524a1.5,1.5,0,0,0,2.993,0c0-.01-.012-21.411-.012-21.419h.044a.5.5,0,0,1,.5.448v9.162a1.247,1.247,0,0,0,2.494,0V32.547A2.981,2.981,0,0,0,13.539,29.611Z" transform="translate(0 -21.818)" fill="#ffeeec" />
                                                                    <path d="M239.523,11.654a1.164,1.164,0,0,0-1.642-.128l-7.322,6.259h-1.084a3.217,3.217,0,0,1-4.371-3.7l-2.621-5.108a1.164,1.164,0,1,0-2.072,1.063l4.685,9.129-1.494,11.8a.648.648,0,0,0,.637.758h.9V40.11a1.4,1.4,0,1,0,2.794,0V31.722h.6v2.8a1.4,1.4,0,0,0,1.137,1.373c4.832.907,4.691.91,4.936.91a1.4,1.4,0,0,0,.258-2.77l-3.537-.67V31.722h.9a.647.647,0,0,0,.637-.758L231.3,20.071s6.854-5.724,8.094-6.775A1.164,1.164,0,0,0,239.523,11.654Z" transform="translate(-205.479 -8.343)" fill="#ffeeec" />
                                                                    <ellipse cx="2.413" cy="2.413" rx="2.413" ry="2.413" transform="matrix(0.987, -0.16, 0.16, 0.987, 19.991, 4.478)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Afterwork</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("utdrikningslag");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.621" height="22.742" viewBox="0 0 25.621 27.742">
                                                                <g transform="translate(0)">
                                                                    <path d="M1601.535,2802.808a2.5,2.5,0,0,0-2-.453,17.6,17.6,0,0,0-.233,2.361,2.463,2.463,0,1,0,4.921,0,13.245,13.245,0,0,0-.116-1.515,3.153,3.153,0,0,1-.948.16A3.014,3.014,0,0,1,1601.535,2802.808Z" transform="translate(-1593.101 -2786.209)" fill="#ffeeec" />
                                                                    <path d="M761.3,2561.018l1.55-.761v-5.222a3.109,3.109,0,0,1-2.152-2.951,28.628,28.628,0,0,1,.548-4.284h-6.018a.231.231,0,0,0-.231.231v5.992a.231.231,0,0,0,.231.231h5.4a.249.249,0,1,1,0,.5h-5.4a.231.231,0,0,0-.231.231v4.654a1.676,1.676,0,0,0,1.675,1.676H760.9a.222.222,0,0,0,.2-.109A.409.409,0,0,1,761.3,2561.018Z" transform="translate(-755 -2533.578)" fill="#ffeeec" />
                                                                    <path d="M1742.8,3552.885V3547.6a2.791,2.791,0,0,1-.28.015,2.627,2.627,0,0,1-.308-.018v5.284a.25.25,0,0,1-.156.231l-.85.344a.166.166,0,0,0,.063.32h2.484a.166.166,0,0,0,.062-.32l-.857-.343A.251.251,0,0,1,1742.8,3552.885Z" transform="translate(-1733.864 -3526.038)" fill="#ffeeec" />
                                                                    <path d="M2223.432,2311.856a15.328,15.328,0,0,1,.16,1.891,3.092,3.092,0,0,1-.143.924h10.05v-1.934a.232.232,0,0,0-.24-.229h-.393a1.518,1.518,0,0,1-1.5-1.561,1.059,1.059,0,0,0-1.058-1.052h-.365a1.047,1.047,0,0,0-1.031,1.068,1.557,1.557,0,0,1-1.556,1.546h-.391a1.518,1.518,0,0,1-1.5-1.561,1.059,1.059,0,0,0-1.057-1.052h-.338a.249.249,0,1,1,0-.5h.391a1.518,1.518,0,0,1,1.5,1.561,1.058,1.058,0,0,0,1.057,1.052h.365a1.047,1.047,0,0,0,1.031-1.067,1.558,1.558,0,0,1,1.556-1.546h.391a1.518,1.518,0,0,1,1.5,1.561,1.059,1.059,0,0,0,1.057,1.052h.339a1.059,1.059,0,0,0,1.057-1.057c0-.445.023-1.67.043-2.629a.617.617,0,0,0-.119-.39.591.591,0,0,0-.473-.235h-10.782a.231.231,0,0,0-.227.276c.226,1.11.5,2.588.675,3.875A.012.012,0,0,1,2223.432,2311.856Z" transform="translate(-2211.975 -2295.24)" fill="#ffeeec" />
                                                                    <path d="M1641.9,2161.373a3,3,0,0,1,2.176.544,2.271,2.271,0,0,0,2.248.318c-.253-1.8-.7-3.952-.9-4.874a.332.332,0,0,0-.325-.261h-2.374C1642.594,2157.7,1642.19,2159.584,1641.9,2161.373Z" transform="translate(-1635.388 -2145.747)" fill="#ffeeec" />
                                                                    <path d="M2042.131,3325.1a3.067,3.067,0,0,1-1.831,1.536v5.213l1.569.761a.41.41,0,0,1,.214.191.22.22,0,0,0,.2.111h13.329v-2.879a1.7,1.7,0,0,1-.219.017h-.375a1.592,1.592,0,0,1-1.567-1.611,1.1,1.1,0,0,0-1.1-1.079h-.39a1.064,1.064,0,0,0-1.054,1.1,1.6,1.6,0,0,1-1.594,1.593h-.375a1.592,1.592,0,0,1-1.568-1.611,1.1,1.1,0,0,0-1.1-1.079h-.389a1.064,1.064,0,0,0-1.054,1.1,1.6,1.6,0,0,1-1.594,1.592h-.349a1.6,1.6,0,0,1-1.594-1.58.254.254,0,0,1,.179-.253.249.249,0,0,1,.319.24,1.1,1.1,0,0,0,1.1,1.1h.389a1.064,1.064,0,0,0,1.054-1.1,1.6,1.6,0,0,1,1.594-1.592h.375a1.592,1.592,0,0,1,1.568,1.611,1.1,1.1,0,0,0,1.1,1.078h.389a1.064,1.064,0,0,0,1.054-1.1,1.6,1.6,0,0,1,1.594-1.592h.375a1.592,1.592,0,0,1,1.567,1.611,1.1,1.1,0,0,0,1.1,1.079h.348a1.1,1.1,0,0,0,1.1-1.1v-2.763a.592.592,0,0,0-.592-.592Z" transform="translate(-2030.863 -3305.171)" fill="#ffeeec" />
                                                                    <path d="M760.183,913.8h-1.96a.231.231,0,0,0-.231.231v3.847a2.48,2.48,0,0,1-.632,1.654l-.914,1.021A5.678,5.678,0,0,0,755,924.338v.729a.231.231,0,0,0,.231.231h6.111c.271-1.421.53-2.573.553-2.674a.249.249,0,0,1,.243-.195h.595a.233.233,0,0,0,.214-.324,5.72,5.72,0,0,0-.987-1.553l-.913-1.021a2.483,2.483,0,0,1-.632-1.654v-3.847A.23.23,0,0,0,760.183,913.8Z" transform="translate(-755 -911.575)" fill="#ffeeec" />
                                                                    <path d="M2740.131,1883.8v-1.965a.333.333,0,0,0-.333-.333h-.166a.333.333,0,0,0-.333.333v1.965a.333.333,0,0,0,.333.333h.166A.333.333,0,0,0,2740.131,1883.8Z" transform="translate(-2724.731 -1872.17)" fill="#ffeeec" />
                                                                    <path d="M2418.18,1219.269a.212.212,0,0,0,.209.176h4.288a.212.212,0,0,0,.209-.176l.448-2.566a.114.114,0,0,0-.16-.123l-1.3.6a.249.249,0,0,1-.332-.124l-.855-1.908a.166.166,0,0,0-.3,0l-.855,1.908a.249.249,0,0,1-.332.124l-1.3-.6a.115.115,0,0,0-.049-.011.112.112,0,0,0-.068.024.108.108,0,0,0-.042.11Z" transform="translate(-2405.524 -1210.613)" fill="#ffeeec" />
                                                                    <path d="M1087.132,612.427h3.068a.233.233,0,0,0,.232-.232v-1.263a.233.233,0,0,0-.232-.232h-3.068a.232.232,0,0,0-.232.232v1.263A.232.232,0,0,0,1087.132,612.427Z" transform="translate(-1084.463 -610.7)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Utdrikningslag</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("digitalt");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.898" height="22.271" viewBox="0 0 26.898 24.271">
                                                                <g transform="translate(0 -25)">
                                                                    <path d="M25.322,25H1.576A1.578,1.578,0,0,0,0,26.576V42.231a1.578,1.578,0,0,0,1.576,1.576H25.322A1.578,1.578,0,0,0,26.9,42.231V26.576A1.578,1.578,0,0,0,25.322,25Z" fill="#fff" />
                                                                    <path d="M98.6,415.312H94.344V413h-8.3v2.312H81.788a.788.788,0,1,0,0,1.576H98.6a.788.788,0,1,0,0-1.576Z" transform="translate(-76.745 -367.617)" fill="#fff" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Digitalt</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("dagsevent");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.125" height="22.125" viewBox="0 0 31.125 31.125">
                                                                <g transform="translate(0 0)">
                                                                    <path d="M72.421,76.549a10.948,10.948,0,0,1,4.128-4.128l-4.712-1.748a.906.906,0,0,0-1.164,1.164Z" transform="translate(-66.324 -66.323)" fill="#ffeeec" />
                                                                    <path d="M4.694,210.931a10.841,10.841,0,0,1,.4-2.917L.528,210.108a.906.906,0,0,0,0,1.647l4.564,2.094a10.841,10.841,0,0,1-.4-2.917Z" transform="translate(0 -195.369)" fill="#ffeeec" />
                                                                    <path d="M210.931,4.694a10.84,10.84,0,0,1,2.917.4L211.754.528a.906.906,0,0,0-1.647,0l-2.094,4.564a10.838,10.838,0,0,1,2.917-.4Z" transform="translate(-195.369 0)" fill="#ffeeec" />
                                                                    <path d="M347.915,76.55l1.748-4.712a.906.906,0,0,0-1.164-1.164l-4.712,1.748A10.949,10.949,0,0,1,347.915,76.55Z" transform="translate(-322.888 -66.324)" fill="#ffeeec" />
                                                                    <path d="M210.931,428.628a10.84,10.84,0,0,1-2.917-.4l2.094,4.564a.906.906,0,0,0,1.647,0l2.094-4.564A10.841,10.841,0,0,1,210.931,428.628Z" transform="translate(-195.369 -402.197)" fill="#ffeeec" />
                                                                    <path d="M72.421,343.787,70.673,348.5a.906.906,0,0,0,1.164,1.164l4.712-1.748A10.948,10.948,0,0,1,72.421,343.787Z" transform="translate(-66.324 -322.888)" fill="#ffeeec" />
                                                                    <path d="M432.794,210.107l-4.564-2.094a10.887,10.887,0,0,1,0,5.834l4.564-2.094a.906.906,0,0,0,0-1.647Z" transform="translate(-402.197 -195.368)" fill="#ffeeec" />
                                                                    <path d="M347.916,343.787a10.947,10.947,0,0,1-4.128,4.128l4.712,1.748a.906.906,0,0,0,1.164-1.164Z" transform="translate(-322.889 -322.888)" fill="#ffeeec" />
                                                                </g>
                                                                <path d="M116.077,125.133a9.057,9.057,0,1,1,9.057-9.057A9.067,9.067,0,0,1,116.077,125.133Z" transform="translate(-100.514 -100.514)" fill="#ffeeec" />
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">På kontoret</p>
                                                </div>
                                            </button>

                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("kurs & konferanse");
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.129" height="22.125" viewBox="0 0 31.129 31.125">
                                                                <g transform="translate(0)">
                                                                    <path d="M19.293,26.375H8.269a.972.972,0,0,1-.961-.825l-1.3-8.43A.972.972,0,0,1,6.973,16H20.59a.973.973,0,0,1,.961,1.122l-1.3,8.43a.972.972,0,0,1-.961.824Z" transform="translate(1.783 4.75)" fill="#ffeeec" />
                                                                    <ellipse cx="5.188" cy="5.188" rx="5.188" ry="5.188" transform="translate(10.377)" fill="#ffeeec" />
                                                                    <path d="M30.11,15.078a9.426,9.426,0,0,0-4.173-7.146,1.966,1.966,0,1,0-.974,1.69,7.475,7.475,0,0,1,3.2,5.456h-2.3a6.167,6.167,0,0,0-6.082-5.188h-8.43a6.167,6.167,0,0,0-6.082,5.188H.973a.989.989,0,0,0-.921,1.31l2.594,7.133a.986.986,0,0,0,.921.635H5.8l-.571-3.67a3.582,3.582,0,0,1,.817-2.866,3.633,3.633,0,0,1,2.71-1.245H22.372A3.566,3.566,0,0,1,25.9,20.486l-.571,3.67h2.231a.986.986,0,0,0,.921-.635l2.594-7.133a.986.986,0,0,0-.964-1.31Z" transform="translate(0.001 1.781)" fill="#ffeeec" />
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Kurs &amp; seminar</p>
                                                </div>
                                            </button>
                                            <button
                                                type="submit"
                                                className="noborder"
                                                onClick={() => {
                                                    setCategory("gratis")
                                                }}
                                            >
                                                <div className="detail-block">
                                                    <div className="icon-container">
                                                        <span className="icon">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="22.242" height="22.35" viewBox="0 0 32.242 27.35">
                                                                <g transform="translate(0 -38.84)">
                                                                    <g transform="translate(25.095 53.606)">
                                                                        <path d="M400.987,273.32h-2.493a6.486,6.486,0,0,1,.393,2.229v9.424a2.778,2.778,0,0,1-.16.931h4.122a2.8,2.8,0,0,0,2.793-2.793v-5.137A4.659,4.659,0,0,0,400.987,273.32Z" transform="translate(-398.494 -273.32)" fill="#ffeeec" />
                                                                    </g>
                                                                    <g transform="translate(0 53.606)">
                                                                        <path d="M6.755,275.551a6.485,6.485,0,0,1,.393-2.229H4.654A4.66,4.66,0,0,0,0,277.975v5.137a2.8,2.8,0,0,0,2.793,2.793H6.915a2.78,2.78,0,0,1-.16-.931Z" transform="translate(0 -273.321)" fill="#ffeeec" />
                                                                    </g>
                                                                    <g transform="translate(8.617 51.181)">
                                                                        <g transform="translate(0 0)">
                                                                            <path d="M147.184,234.815h-5.7a4.66,4.66,0,0,0-4.654,4.654v9.424a.931.931,0,0,0,.931.931h13.147a.931.931,0,0,0,.931-.931v-9.424A4.66,4.66,0,0,0,147.184,234.815Z" transform="translate(-136.829 -234.815)" fill="#ffeeec" />
                                                                        </g>
                                                                    </g>
                                                                    <g transform="translate(10.524 38.84)">
                                                                        <g transform="translate(0 0)">
                                                                            <path d="M172.711,38.84a5.6,5.6,0,1,0,5.6,5.6A5.6,5.6,0,0,0,172.711,38.84Z" transform="translate(-167.114 -38.84)" fill="#ffeeec" />
                                                                        </g>
                                                                    </g>
                                                                    <g transform="translate(2.106 44.057)">
                                                                        <g transform="translate(0 0)">
                                                                            <path d="M37.629,121.689a4.184,4.184,0,1,0,4.186,4.186A4.191,4.191,0,0,0,37.629,121.689Z" transform="translate(-33.443 -121.689)" fill="#ffeeec" />
                                                                        </g>
                                                                    </g>
                                                                    <g transform="translate(21.764 44.057)">
                                                                        <g transform="translate(0 0)">
                                                                            <path d="M349.793,121.689a4.186,4.186,0,1,0,4.186,4.186A4.191,4.191,0,0,0,349.793,121.689Z" transform="translate(-345.607 -121.689)" fill="#ffeeec" />
                                                                        </g>
                                                                    </g>
                                                                </g>
                                                            </svg>
                                                        </span>
                                                    </div>
                                                    <p className="detail-info">Gratis</p>
                                                </div>
                                            </button>
                                        </div>
                                    </form>
                                    <div className="sub-title mb-1">
                                        <span className="counter" style={{ visibility: 'visible' }}>
                                            <span className="activitet_currently text-center" style={{ transform: "translateY(36px)" }}>
                                                {activityCounter}
                                            </span>
                                        </span> GØYE OPPLEVELSER
                                    </div>
                                </div>
                                <div className="mbl d-sm-none">
                                    <div className="text-content">
                                        <h2 className="title"> MARKEDSPLASSEN <br />
                                            <span className="highlights"> FOR SOSIALE AKTIVITETER</span>
                                        </h2>
                                    </div>
                                </div>
                                <div className="cards-content">
                                    <div className="cards-container">
                                        {imagesHeader &&
                                            imagesHeader[indexes] &&
                                            indexes !== undefined &&
                                            imagesHeader[indexes] &&
                                            <div className="card-block" >
                                                <Link to={`/${getUrlFriendlyString(imagesHeader[indexes].name, imagesHeader[indexes].category)}?id=${imagesHeader[indexes].id}`}>

                                                <div className="img-container">

                                                    <img
                                                        src={
                                                            imagesHeader &&
                                                                imagesHeader[indexes] &&
                                                                indexes !== undefined &&
                                                                imagesHeader[indexes] &&
                                                                imagesHeader[indexes].thumbnailImage
                                                                ? imagesHeader[indexes].thumbnailImage
                                                                : '' // Provide a fallback image URL or handle missing image
                                                        }
                                                        alt="picture"
                                                    />


                                                </div>
                                                <div className="description">
                                                    {/*<div className="text-block">*/}
                                                    {/*    <div className="details">*/}
                                                    {/*    <p className="lbl-title">{imagesHeader[indexes].name}</p>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    <div className="text-block">
                                                        <div className="details">
                                                            <p className="lbl-title">{imagesHeader[indexes].name}</p>

                                                            {/*<p className="lbl mb-0 trim-text" dangerouslySetInnerHTML={{ __html: truncateHTML(imagesHeader[0][indexes].description, 32)  }}></p>*/}
                                                        </div>
                                                        <div className="btn-block">-{imagesHeader[indexes].discountPercent}%</div>
                                                    </div>
                                                    <div className="text-block">
                                                        <div className="details">
                                                            <p className="bottom-title">NOK {imagesHeader[indexes].price}</p>
                                                        </div>
                                                        <Link to={`/${getUrlFriendlyString(imagesHeader[indexes].name, imagesHeader[indexes].category)}?id=${imagesHeader[indexes].id}`}><div className="learn-more">Les mer</div></Link>
                                                    </div>
                                                    </div>
                                                </Link> 
                                                </div>
                                        }
                                        {imagesHeader &&
                                            imagesHeader[indexes] &&
                                            indexes !== undefined &&
                                            imagesHeader[indexes + 1] &&



                                            <div className="card-block" >
                                                <Link to={`/{getUrlFriendlyString(imagesHeader[indexes + 1].name, imagesHeader[indexes + 1].category)}?id=${imagesHeader[indexes + 1].id}`}>

                                                <div className="img-container">

                                                    <img
                                                        src={
                                                            imagesHeader &&
                                                                imagesHeader[indexes] &&
                                                                indexes !== undefined &&
                                                                imagesHeader[indexes+1] &&
                                                                imagesHeader[indexes+1].thumbnailImage
                                                                ? imagesHeader[indexes+1].thumbnailImage
                                                                : '' // Provide a fallback image URL or handle missing image
                                                        }
                                                        alt="picture"
                                                    />


                                                </div>
                                                <div className="description">
                                                    {/*<div className="text-block">*/}
                                                    {/*    <div className="details">*/}
                                                    {/*    <p className="lbl-title">{imagesHeader[1][indexes].name}</p>*/}
                                                    {/*    </div>*/}
                                                    {/*</div>*/}
                                                    <div className="text-block">

                                                        <div className="details">
                                                            <p className="lbl-title">{imagesHeader[indexes+1].name}</p>

                                                            {/*                                                              <p className="lbl mb-0 trim-text" dangerouslySetInnerHTML={{ __html: truncateHTML(imagesHeader[1][indexes].description, 32)  }}></p>*/}
                                                        </div>
                                                        <div className="btn-block">-{imagesHeader[indexes+1].discountPercent}%</div>
                                                    </div>
                                                    <div className="text-block">
                                                        <div className="details">
                                                            <p className="bottom-title">NOK {imagesHeader[indexes+1].price}</p>
                                                        </div>
                                                            <Link to={`/${getUrlFriendlyString(imagesHeader[indexes + 1].name, imagesHeader[indexes+1].category)}?id=${imagesHeader[indexes+1].id}`}><div className="learn-more">Les mer</div></Link>
                                                    </div>
                                                    </div>
                                                </Link>

                                                </div>

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="funtlers-card-section lg-container">
                    <div className="container-fluid">
                        <div className="card-info-container">
                            <div className="top-content">
                                <h2 className="title">VÅRE GAVETIPS</h2>
                                <p className="detail-text mx-auto"> Hos Funtlers kan du også kjøpe gavekort til noen du er glad i, eller som bedriftsgave. Du får gavekortet sendt direkte til din epost øyeblikkelig etter bestilling. Her er noen forslag: </p>
                            </div>
                            <div className="funtlers-cards-container position-relative">
                                <div className="swiper card-swiper swiper-initialized swiper-horizontal swiper-backface-hidden">
                                    <div
                                        className={`swiper-wrapper ${activeSlide !== 0 ? 'slide-transition' : ''}`}
                                        id="swiper-wrapper-29bff1a297fec95e"
                                        aria-live="polite"
                                        style={{
                                            transform: `translateX(-${activeSlide * slideWidth}px)`,
                                            transition: 'transform 0.4s cubic-bezier(0.22, 0.61, 0.36, 1)',
                                            gap: '12px' // ← Add this
                                        }}

                                         >
                                    
                                        {imagesHeader &&
                                            customfilter(imagesHeader)?.map((item, index) => (
                                                <div
                                                    key={index}
                                                    className="swiper-slide"
                                                    style={{ width: '330.667px' }}
                                                    role="group"
                                                    aria-label={`${index + 1} / ${imagesHeader[0].length}`}
                                                >
                                                    <div className="card-block">
                                                        <Link className="btn" to={`/${getUrlFriendlyString(item.name, item.category)}?id=${item.id}`}>

                                                        <div className="img-container">
                                                            <img src={item.thumbnailImage} alt="card" />
                                                        </div>
                                                        <div className="text-description">
                                                            <div className="text-block">
                                                                <h6 className="title-desc">{item.name}</h6>
                                                                <p className="description" dangerouslySetInnerHTML={{ __html: truncateHTML(item.description, 100) }}></p>
                                                            </div>
                                                            <div className="btn-container">
                                                                <Link className="btn" to={`/${getUrlFriendlyString(item.name,item.category)}?id=${item.id}`}>
                                                                    Les Mer Og Bestill Gaven
                                                                </Link>
                                                            </div>
                                                            </div>
                                                        </Link>
                                                    </div>
                                                </div>
                                            ))}
                                    </div>
                                    <span className="swiper-notification" aria-live="assertive" aria-atomic="true" />
                                </div>
                                <div
                                    className="swiper-button-next d-sm-flex d-none"
                                    tabIndex={-1}
                                    role="button"
                                    aria-label="Next slide"
                                    aria-controls="swiper-wrapper-29bff1a297fec95e"
                                    aria-disabled="true"
                                    onClick={handleNextClick}
                                />
                                <div
                                    className="swiper-button-prev d-sm-flex d-none"
                                    tabIndex={0}
                                    role="button"
                                    aria-label="Previous slide"
                                    aria-controls="swiper-wrapper-29bff1a297fec95e"
                                    aria-disabled="false"
                                    onClick={handlePreviousClick}
                                />
                                <div className="d-sm-none mbl-swiper-btn">
                                    <div
                                        className="swiper-button-prev"
                                        tabIndex={0}
                                        role="button"
                                        aria-label="Previous slide"
                                        aria-controls="swiper-wrapper-29bff1a297fec95e"
                                        aria-disabled="false"
                                        onClick={handlePreviousClick}
                                    />
                                    <div
                                        className="swiper-button-next"
                                        tabIndex={-1}
                                        role="button"
                                        aria-label="Next slide"
                                        aria-controls="swiper-wrapper-29bff1a297fec95e"
                                        aria-disabled="true"
                                        onClick={handleNextClick}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            { /*
              <section className="hero_header">
                  <div className="thrios d-flex justify-content-center">
                      <div className="aside">

                          {imagesHeader[0][indexes] != null ? <Link to={`/aktivitet/${getUrlFriendlyString(imagesHeader[0][indexes].name)}?id=${imagesHeader[0][indexes].id}`}><div className="bubbles" onClick={() => handleActivityPage(imagesHeader[0][indexes].name, imagesHeader[0][indexes].id)}><img src={`${imagesHeader[0][indexes].thumbnailImage}`} alt="Header image" className="bubble1 bubble" />{imagesHeader[0][indexes].discountPercent > 0 ? <p className="discountbubble">-{imagesHeader[0][indexes].discountPercent}%</p> : ""}</div></Link> : ""}
                          {imagesHeader[1][indexes] != null ? <Link to={`/aktivitet/${getUrlFriendlyString(imagesHeader[1][indexes].name)}?id=${imagesHeader[1][indexes].id}`}><div className="bubbles" onClick={() => handleActivityPage(imagesHeader[1][indexes].name, imagesHeader[1][indexes].id)}><img src={`${imagesHeader[1][indexes].thumbnailImage}`} alt="Header image" className="bubble1 bubble" />{imagesHeader[1][indexes].discountPercent > 0 ? <p className="discountbubble">-{imagesHeader[1][indexes].discountPercent}%</p> : ""}</div></Link> : ""}
                      </div>
                      <div className="Hero_main">
                          <div className="container col_team_building_otr">
                              <div className="activitet_currently text-center" style={{ transform: "translateY(36px)" }}>
                                  <h4 style={{ fontSize: "120px" }}>{activityCounter}</h4>
                              </div>
                              <div className="thrio d-flex">
                                  <div className="header_content d-flex flex-column align-items-center">
                                      <h1 style={{ fontSize: "120px" }}>GØYE</h1>
                                      <h5 className="text-center under_Goye" style={{ fontSize: "120px" }}>AKTIVITETER</h5>
                                  </div>
                              </div>
                              <div className="body_building_otr">
                                  <div className="col_team_building_inr">
                                      <div className="promotes">
                                          <h1 className="heading-lb mb-2 text-capitalize text-center" style={{ fontSize: "25px" }}>
                                              RABATTER PÅ ALT
                                          </h1>
                                          <form className="teambuilding_Form" onSubmit={handleSubmit}>
                                              <div className="activity_main">
                                                  <ul className="activity_ul">
                                                      <li className="activity_li">
                                                          <Select
                                                              options={filters.types}
                                                              defaultText="Acitivity Type"
                                                              value={type}
                                                              setValue={setType}
                                                          />
                                                      </li>
                                                     
                                                      <li className="activity_li">
                                                          <Select
                                                              value={city}
                                                              setValue={setCity}
                                                              options={filters.cities}
                                                              defaultText="Cities"
                                                              disabled={type === "digital"}
                                                          />
                                                      </li>
                                                      <li className="activity_li">
                                                          <Select
                                                              value={budget}
                                                              setValue={setBudget}
                                                              options={filters.budgetOptions}
                                                              defaultText="Budget Options"
                                                          />
                                                      </li>
                                                      <li className="activity_li last">
                                                          <Select
                                                              setValue={setPeopleNumber}
                                                              value={peopleNumber}
                                                              options={filters.peopleNumber}
                                                              defaultText="Number of people"
                                                          />
                                                      </li>
                                                  </ul>
                                                  <div className="search_icon_otr_local">
                                                      <button
                                                          className="ri-search-2-line search_icon_local"
                                                          type="submit"
                                                      ></button>
                                                  </div>
                                              
                                              </div>
                                          </form>
                                          <form onSubmit={handleSubmit}>
                                              <div className="col_inpiration_inr">
                                                  <h3 className="heading-lb text-center my-2" style={{ fontSize: "25px" }}>
                                                      INSPIRASJON
                                                  </h3>
                                                  <ul className="inspiration_ul">
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("vennegjeng");
                                                              }}
                                                          >
                                                              Vennegjeng
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("datenight");
                                                              }}
                                                          >
                                                              Datenight
                                                          </button>
                                                      </li>
                                                   
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("bursdag");
                                                              }}
                                                          >
                                                              Bursdag
                                                          </button>
                                                      </li>
                                                     
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("familiedag");
                                                              }}
                                                          >
                                                              Familiedag
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("egentid");
                                                              }}
                                                          >
                                                              Egentid
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("dagsutflukt");
                                                              }}
                                                          >
                                                              Dagsutflukt
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("teambuilding");
                                                              }}
                                                          >
                                                              Teambuilding
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("sommerfest");
                                                              }}
                                                          >
                                                              Julebord
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("afterWork");
                                                              }}
                                                          >
                                                              After work
                                                          </button>
                                                      </li>
                                                   
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("utdrikningslag");
                                                              }}
                                                          >
                                                              Utdrikningslag
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("digitalt");
                                                              }}
                                                          >
                                                              Digitalt
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("dagsevent");
                                                              }}
                                                          >
                                                              Dagsevent
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setCategory("kurs & konferanse");
                                                              }}
                                                              style={{ lineHeight: "18px" }}
                                                          >
                                                              Kurs & Konferanse
                                                          </button>
                                                      </li>
                                                      <li className="inspiration_li">
                                                          <button
                                                              className="inspiration_btn Theme_btn_primary_inspiration"
                                                              onClick={() => {
                                                                  setBudget("0");
                                                              }}
                                                          >
                                                              Gratis
                                                          </button>
                                                      </li>
                                                  </ul>
                                              </div>
                                          </form>
                                      </div>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <div className="aside">
                          {imagesHeader[2][indexes] != null ? <Link to={`/aktivitet/${getUrlFriendlyString(imagesHeader[2][indexes].name)}?id=${imagesHeader[2][indexes].id}`}><div className="bubbles" onClick={() => handleActivityPage(imagesHeader[2][indexes].name, imagesHeader[2][indexes].id)}><img src={`${imagesHeader[2][indexes].thumbnailImage}`} alt="Header image" className="bubble1 bubble" />{imagesHeader[2][indexes].discountPercent > 0 ? <p className="discountbubble">-{imagesHeader[2][indexes].discountPercent}%</p> : ""}</div></Link> : ""}
                          {imagesHeader[3][indexes] != null ? <Link to={`/aktivitet/${getUrlFriendlyString(imagesHeader[3][indexes].name)}?id=${imagesHeader[3][indexes].id}`}><div className="bubbles" onClick={() => handleActivityPage(imagesHeader[3][indexes].name, imagesHeader[3][indexes].id)}><img src={`${imagesHeader[3][indexes].thumbnailImage}`} alt="Header image" className="bubble1 bubble" />{imagesHeader[3][indexes].discountPercent > 0 ? <p className="discountbubble">-{imagesHeader[3][indexes].discountPercent}%</p> : ""}</div></Link> : ""}
                      </div>
                  </div>
              </section>
              */
            }
        </>
    );
}

export default Hero;
